module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recommended_categories":"Popular Categories","category_list":"All Categories"},"ja":{"recommended_categories":"おすすめカテゴリー","category_list":"カテゴリー一覧"}}')
  delete Component.options._Ctor
}
